module.exports = __webpack_public_path__ + "assets/images/gana-background-login.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=assets/images/[name].[ext]!./src/assets/images/gana-background-login.jpg
// module id = 203
// module chunks = 15